import difference from 'lodash/difference'
import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'
import { matchText, normalizeText } from 'modules/core/lib/stringUtils'

interface IValue {
  [key: string]: any
}

class Value extends Model<IValue> {
  static FixedAttributes = ['id', 'resource_id', 'permissions']

  constructor(attr: IValue = {}) {
    super(attr)
    makeObservable(this, {
      customFieldsIds: computed,
      customFieldsValues: computed,
    })
  }

  static urlRoot() {
    return '/custom_resources/values'
  }

  get customFieldsIds(): string[] {
    const attributes = Object.keys(this.toJS())

    return difference(attributes, Value.FixedAttributes)
  }

  get customFieldsValues(): any[] {
    return this.customFieldsIds.map((a) => normalizeText(String(this.attributes[a])))
  }

  matchCustomFieldValue(value: string) {
    return this.customFieldsValues.some((a) => matchText(value, a))
  }
}

export default Value
